import locTypeWithField from "./locTypeWithField.vue";
export default locTypeWithField;
